import Number from './Number';

export default Number;
